<div class="grid mt-2">
  <div class="col-12 lg:col-6 md:col-12 sm:col-12 group-container">
    @if (selectedGroup) {
    <h2>{{selectedGroup.Description}}</h2>
    <div class="grid">
      <div class="col-12 lg:col-6 md:col-12 sm:col-12">
        <img class="w-full shadow-2 border-round" [src]="selectedGroup.Topic | stationImage" [alt]="selectedGroup.Description" />
      </div>
      <div class="col-12 lg:col-6 md:col-12 sm:col-12">
        <h4>Hours</h4>
        @for (day of selectedGroup.Weekdays; track day.WeekdayInt) {
        <div class="flex gap-1">
          <div class="day">• {{day.Weekday}}: </div>
          <div class="hours">{{day | stationHours}}</div>
        </div>
        }
      </div>
    </div>
    <p>{{selectedGroup.WebDescription}}</p>
    }
  </div>
  <div class="col-12 lg:col-6 md:col-12 sm:col-12">
    <router-outlet></router-outlet>
  </div>
</div>